export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10830.3f86b329.jpg";